
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-15 197.8 460 446.2"}},[_c('path',{attrs:{"d":"M210.7 519c-1.4 0-87.6 119.4-88.3 119.4s-86.2-60.2-86.5-60.9c-.3-.8 86.2-125.2 86.2-126.9 0-2.2-129.1-43.8-137-46.9-1.3-.5 31.3-101.4 31.6-101.7.6-.7 143.8 46.8 144.9 46.8.4 0 .9-.6 1-1.3.4-2 1-148 1.7-149 .8-1.2 104.1-.7 104.7-.3 1.5 1 3.5 155.4 6.1 155.4 1.4 0 138.1-46.8 138.7-46.1.8.9 31.8 101.8 31.4 102.2-.9.9-139.6 46.9-140 48.6-.3 1.4 82.5 121.6 82.2 122.4-.2.7-85.1 63.2-85.9 63.2-1.3-.1-88.9-124.9-90.8-124.9z"}})])
      }
    
      }
    